import * as React from 'react';

import { Modal } from '@material-ui/core';
import { changeEmail } from '../services/api';
import { toast } from 'react-toastify';

export default function ChangeEmailModal({ params, openModal, setOpenModal }) {
  const [newEmail, setNewEmail] = React.useState('');
  const [disabled, setDisabled] = React.useState(false);
  const onChangeButtonClicked = async () => {
    setDisabled(true);
    try {
      await changeEmail({
        oldEmail: params.data.email,
        newEmail,
      });
      setOpenModal(false);
      toast.success('Email changed successfully');
    } catch (e) {
      console.error(e);
      let message;
      if ([400, 500].includes(e.response?.status) && e.response?.data?.message)
        message = e.response.data.message;
      else message = 'Error changing email';
      toast.error(message);
    } finally {
      setDisabled(false);
    }
  };

  return (
    <Modal open={openModal}>
      <div className='relative overflow-y-auto max-h-96 top-2 md:top-10 m-auto bg-ab-tertiary bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600 p-50'>
        <div
          className='absolute right-2 top-2 cursor-pointer'
          onClick={() => {
            setOpenModal(false);
          }}
        >
          X
        </div>
        <h2 className='font-bold text-center text-lg'>
          Put the new email here
        </h2>

        <hr />
        <div className='flex justify-center mt-10'>
          <input
            type='text'
            className='border border-solid mb-3 outline-none p-1 rounded flex-grow'
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            placeholder='Enter new email'
          />
        </div>
        <div className='flex justify-end items-center mt-4'>
          <button
            className={`bg-red-c3 p-1 px-2 rounded-md text-white ${
              disabled ? 'cursor-not-allowed' : ''
            }`}
            onClick={onChangeButtonClicked}
            disabled={disabled}
          >
            Change Email
          </button>
        </div>
      </div>
    </Modal>
  );
}
